import dataPeriTarDaptAsa from "../../../../src/data/periprocedureel-beleid-tar-dapt-asa-dip.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataPeriTarDaptAsa,
  BasicSchematic,
  React
};